<template>
  <div>
    <div class="text-xl font-bold">On trip menu</div>
    <p
      class="w-full mt-3 text-sm font-medium lg:w-3/4"
    >Available services are listed as amenities in your ticket.</p>
    <p class="w-full mt-1 text-sm font-medium lg:w-3/4">Please check your ticket before purchasing.</p>
    <div class="flex flex-wrap items-center mt-8">
      <div
        class="mb-5 mr-10 bg-white rounded-md shadow"
        v-for="product in products"
        :key="product.id"
      >
        <div class="flex flex-col items-center justify-center px-6 pt-6 pb-2">
          <svg width="22" height="56" xmlns="http://www.w3.org/2000/svg">
            <g fill-rule="nonzero" fill="none">
              <path
                d="M20.533 18.308c-.08-2.229-.393-3.883-1.601-6.402-1.679-3.502-6.428-6.476-6.428-6.476V3.56H7.647v1.886L4.566 8.013C.482 11.518.046 16.087.109 18.308h20.424z"
                fill="#EDEDED"
              />
              <path
                d="M19.844 52.197c-2.208 5.037-6.302 2.543-6.302 2.543l-.74.658a1.953 1.953 0 01-1.297.493h-.283a1.95 1.95 0 01-1.48-.682l-.725-.839s-1.791 2.147-4.451 1.12C1.904 54.461.289 51.005.103 48.16c-.187-2.848.682-5.507 1.148-7.656.308-1.414-.235-4.617-.642-6.634a19.547 19.547 0 01-.283-1.854c-.067-.67 3.3-1.834 3.3-2.509L.224 20.136v-.5s-.303-1.645.052-3.89h19.992c.253 1.32.29 2.63.293 4.352.003.367-3.189 1.591-3.189 1.998v7.1c0 .933 3.125 1.898 2.99 2.82-.04.286-.086.569-.138.851-.425 2.288-1.027 6.307-.43 8.106.864 2.59 2.256 6.188.05 11.224z"
                fill="#293B44"
              />
              <g fill="#DE594E">
                <path
                  d="M12.631 4.26H7.36a.712.712 0 01-.711-.712V.759c0-.393.318-.711.711-.711h5.272c.393 0 .712.318.712.711v2.789a.712.712 0 01-.712.711zM20.564 21.259v7.969c0 .933-.067 1.866-.201 2.788H.326A20.26 20.26 0 01.224 30v-9.901h20.337c.003.367.003.754.003 1.16z"
                />
              </g>
            </g>
          </svg>
          <div class="mt-2 text-xs font-medium text-dark-type-4">{{ product.name }}</div>
          <div class="text-xs font-bold">&#8358;{{ product.amount }}</div>
        </div>
        <div
          class="px-4 py-3 font-bold text-white bg-active cursor-pointer rounded-b-md"
          @click="addToCart(product)"
        >Add to cart</div>
      </div>
    </div>
    <div
      class="fixed flex items-center justify-center w-16 h-16 bg-active rounded-full cursor-pointer"
      @click="showCart = true"
      style="bottom: 4%; right: 10%;"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 172 172">
        <g
          fill="none"
          stroke-miterlimit="10"
          font-family="none"
          font-weight="none"
          font-size="none"
          text-anchor="none"
          style="mix-blend-mode:normal"
        >
          <path d="M0 172V0h172v172z" />
          <path
            d="M11.467 11.467a5.734 5.734 0 100 11.466h10.772c1.295 0 2.376.811 2.744 2.06l24.433 83.067c2.145 7.291 8.889 12.34 16.495 12.34h62.932c7.731 0 14.557-5.225 16.596-12.676l14.893-54.612a5.734 5.734 0 00-5.532-7.245H43.078l-7.088-24.11h-.011c-1.788-6.077-7.41-10.29-13.74-10.29zm57.333 120.4c-6.333 0-11.467 5.133-11.467 11.466 0 6.333 5.134 11.467 11.467 11.467s11.467-5.134 11.467-11.467-5.134-11.466-11.467-11.466zm57.333 0c-6.333 0-11.466 5.133-11.466 11.466 0 6.333 5.133 11.467 11.466 11.467 6.333 0 11.467-5.134 11.467-11.467s-5.134-11.466-11.467-11.466z"
            fill="#fff"
          />
        </g>
      </svg>
      <div
        class="absolute top-0 right-0 flex items-center justify-center w-5 h-5 font-bold text-white rounded-full text-xxs bg-red-type-1"
      >{{ cart.length }}</div>
    </div>
    <portal to="flyout-sidebar" v-if="showCart">
      <div class="fixed top-0 bottom-0 right-0 w-full min-h-screen lg:absolute lg:w-1/4">
        <div class="flex flex-col justify-between h-full px-6 py-6 overflow-y-auto bg-white shadow-type-1">
          <div>
            <div class="cursor-pointer" @click="showCart = false">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none" fill-rule="evenodd">
                  <circle cx="12" cy="12" r="12" fill="#FCFCFC" />
                  <path
                    d="M16 8l-8 8m0-8l8 8"
                    stroke="#131615"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                </g>
              </svg>
            </div>
            <div class="mt-10 font-bold text-dark-type-3">Your cart</div>
            <div class="h-64 overflow-y-auto" v-if="cart.length > 0">
              <div
                class="flex items-center justify-between mt-8"
                v-for="item in cart"
                :key="item.id"
              >
                <div class="text-sm font-bold">{{ item.name }}</div>
                <div class="flex items-center border border-gray-type-4">
                  <div
                    class="px-4 py-1 text-sm font-medium cursor-pointer bg-gray-type-5 rounded-l-md"
                    @click="decrementQuantity(item)"
                  >-</div>
                  <div class="px-4 py-1 text-xs">{{ item.quantity }}</div>
                  <div
                    class="px-4 py-1 text-sm font-medium cursor-pointer bg-gray-type-5 rounded-r-md"
                    @click="incrementQuantity(item)"
                  >+</div>
                </div>
              </div>
            </div>
            <template v-else>
              <div class="py-10 text-center">Cart is empty</div>
            </template>
          </div>
          <div v-if="cart.length > 0">
            <div class="mt-10 font-bold text-dark-type-3 lg:mt-0">Summary</div>
            <div class="h-64 overflow-y-auto">
              <div
                class="flex items-center justify-between mt-6"
                v-for="item in cart"
                :key="item.id"
              >
                <div class="text-sm font-medium">{{ item.name }}</div>
                <div
                  class="text-sm font-medium"
                >{{ item.quantity }} at &#8358;{{ item.amount | currency(0) }} each</div>
              </div>
              <div class="flex items-center justify-between mt-6">
                <div class="text-sm font-medium">Total</div>
                <div class="text-sm font-medium">&#8358;{{ cartTotal | currency }}</div>
              </div>
            </div>
            <button
              @click="showCheckoutModal = true"
              class="block w-full h-12 py-4 mt-8 font-bold text-center text-white bg-active rounded focus:outline-none"
            >Checkout</button>
          </div>
        </div>
      </div>
    </portal>
    <modal :show="showCheckoutModal" @close="showCheckoutModal = false">
      <div class="relative px-6 py-3 pb-6 text-dark-type-4">
        <div class>
          <div class="cursor-pointer" @click="showCheckoutModal = false">
            <svg class="absolute" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
              <g fill="none" fill-rule="evenodd">
                <circle cx="12" cy="12" r="12" fill="#FCFCFC" />
                <path
                  d="M16 8l-8 8m0-8l8 8"
                  stroke="#131615"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </div>
          <div class="mx-auto font-bold text-center text-dark-type-3">Payment breakdown</div>
        </div>
        <div class="mt-12">
          <div class="h-64 overflow-y-auto">
            <div class="flex items-center justify-between mt-6" v-for="item in cart" :key="item.id">
              <div class="text-xs font-medium text-dark-type-4">{{ item.name }}</div>
              <div
                class="text-xs font-medium text-dark-type-3"
              >{{ item.quantity }} at &#8358;{{ item.amount | currency(0) }} each</div>
            </div>
          </div>
          <div class="flex items-center justify-between mt-4">
            <div class="text-xs font-bold text-dark-type-3">Total deduction</div>
            <div class="text-xs font-bold text-dark-type-3">&#8358; {{ cartTotal | currency }}</div>
          </div>
          <div class="flex items-center justify-between mt-4">
            <div class="text-xs font-bold text-dark-type-3">Wallet balance</div>
            <div class="text-xs font-bold text-dark-type-3">&#8358; {{ wallet.amount | currency }}</div>
          </div>
        </div>
        <div class="px-4 py-4 mt-10 text-white rounded bg-red-type-1" v-if="!canCoverFees">
          <div class="text-xs font-bold">Insufficient balance</div>
          <div
            class="mt-2 text-xs"
          >Your wallet balance is insufficient for this payment. Fund to continue</div>
        </div>
        <button
          @click="checkout"
          v-if="canCoverFees"
          class="block w-full h-12 py-4 mt-8 font-bold text-center text-white rounded focus:outline-none"
          :class="processing ? 'bg-gray-type-7' : 'bg-active'"
        >{{ processing ? 'Processing' : `Pay &#8358; ${cartTotal}` }}</button>
        <router-link
          v-else
          :to="{ name: 'dashboard.wallet' }"
          class="block w-full h-12 py-4 mt-8 font-bold text-center text-white bg-active rounded"
        >Fund Wallet</router-link>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "@/components/Modal";

export default {
  components: {
    Modal
  },
  data() {
    return {
      form: {
        code: ""
      },
      showAddPromo: false,
      processing: false,
      products: [
        {
          id: 1,
          name: "50cl drink",
          amount: 500
        },
        {
          id: 2,
          name: "50cl drink",
          amount: 500
        },
        {
          id: 3,
          name: "50cl drink",
          amount: 500
        },
        {
          id: 4,
          name: "50cl drink",
          amount: 500
        },
        {
          id: 5,
          name: "50cl drink",
          amount: 500
        },
        {
          id: 6,
          name: "50cl drink",
          amount: 500
        },
        {
          id: 7,
          name: "50cl drink",
          amount: 500
        },
        {
          id: 8,
          name: "50cl drink",
          amount: 500
        }
      ],
      cart: [],
      showCart: false,
      showCheckoutModal: false
    };
  },
  validations: {
    form: {}
  },
  computed: {
    ...mapGetters("app", ["wallet"]),
    cartTotal() {
      return this.cart.reduce(
        (acc, item) => acc + item.amount * item.quantity,
        0
      );
    },
    canCoverFees() {
      return parseInt(this.wallet.amount) >= this.cartTotal;
    }
  },
  methods: {
    addToCart(product) {
      const index = this.cart.findIndex(item => item.id === product.id);

      if (index === -1) {
        this.cart.push({ ...product, quantity: 1 });
      }
    },
    decrementQuantity(product) {
      const index = this.cart.findIndex(item => item.id === product.id);

      if (index === -1 || product.quantity - 1 <= 0) {
        return;
      }

      this.$set(this.cart, index, {
        ...product,
        quantity: product.quantity - 1
      });
    },
    incrementQuantity(product) {
      const index = this.cart.findIndex(item => item.id === product.id);

      if (index === -1) {
        return;
      }

      this.$set(this.cart, index, {
        ...product,
        quantity: product.quantity + 1
      });
    },
    checkout() {
      
    }
  }
};
</script>